import { Base } from "@studiometa/js-toolkit";
import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

export default class SliderProduct extends Base {
  static config = {
    name: 'SliderProduct',
    refs: ['wrapper', 'slides[]', 'scrollbar'],
    log: true,
  };

  mounted() {
    this.$log('mounted swipe');
    this.init();

    // Écouter l'événement de mise à jour de la galerie
    this._boundReinit = this.reinit.bind(this);
    this.$el.addEventListener('gallery:updated', this._boundReinit);

    // Gérer le redimensionnement de la fenêtre
    this._boundHandleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this._boundHandleResize);
  }

  destroyed() {
    this.$el.removeEventListener('gallery:updated', this._boundReinit);
    window.removeEventListener('resize', this._boundHandleResize);

    if (this.slider) {
      this.slider.destroy(true, true);
    }
  }

  handleResize() {
    if (this.slider) {
      this.slider.update();
    }
  }

  init() {
    if (!this.$refs.slides.length) {
      this.$destroy();
      return;
    }

    this.slider = new Swiper(this.$el, {
      modules: [Scrollbar],
      direction: 'horizontal',
      slidesPerView: 1,
      allowTouchMove: true,
      scrollbar: {
        el: this.$refs.scrollbar,
        draggable: true,
        hide: false,
        dragSize: 'auto',
      },
      breakpoints: {
        1024: {
          enabled: false
        }
      }
    });
  }

  refresh() {
    if (this.slider) {
      this.slider.update();
      this.slider.slideTo(0, 0); // Retour à la première slide sans animation
    }
  }

  reinit() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }

    this.$update();
  }
}
